<template>
  <div class="text-center">
    <v-bottom-sheet v-model="show" inset persistent>
      <v-sheet
        class="console text-left py-1 px-1"
        style="overflow-y: scroll"
        height="300px"
        color="black"
      >
        <template v-for="item in logger.slice().reverse()">
          <div
            v-if="item.type === 'error'"
            style="color: red"
            v-bind:key="item.date"
          >
            {{ item.date }} - <b>{{ item.title }}</b> - {{ item.message }}
          </div>
          <div
            v-if="item.type === 'debug'"
            style="color: yellow"
            v-bind:key="item.date"
          >
            {{ item.date }} - <b>{{ item.title }}</b> - {{ item.message }}
          </div>
          <div
            v-if="item.type === 'info'"
            style="color: green"
            v-bind:key="item.date"
          >
            {{ item.date }} - <b>{{ item.title }}</b> - {{ item.message }}
          </div>
        </template>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  name: "ErrorConsole",
  props: {
    logger: Array,
  },
  data: () => ({
    show: true,
  }),
};
</script>

<style scoped>
</style>